var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPollsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.519,
    height: 34.59,
    viewBox: "0 0 33.519 34.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.029,
    x2: 0,
    y2: 1.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4adede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6172d6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M1413.718,529.38h.118a2.823,2.823,0,0,1,2.96,2.471l0,.09v29.505a2.817,2.817,0,0,1-2.978,2.524h-2.11c-.047,0-.095,0-.142,0h-.059a2.9,2.9,0,0,1-2.918-2.094l-.057-.06,0-.409-.011-29.483v-.017a2.8,2.8,0,0,1,2.957-2.527h2.135Zm.934,2.568c-.029-.245-.386-.519-.876-.539h-2.221c-.509.014-.874.3-.891.554l.011,29.417c.024.256.39.543.9.562h2.178c.512-.017.881-.305.9-.561Zm-26.175,6.629a2.823,2.823,0,0,1,2.96,2.471l0,.09v20.309a2.818,2.818,0,0,1-2.978,2.524h-2.193a2.824,2.824,0,0,1-2.977-2.515v-.045l-.011-20.289v-.016a2.8,2.8,0,0,1,2.957-2.527h2.135Zm.934,2.57c-.033-.26-.429-.542-.934-.542h-2.241c-.516,0-.912.29-.93.554l.011,20.221c.025.269.414.563.95.563h2.155c.544.016.967-.287.989-.561Zm11.687,6.627a2.822,2.822,0,0,1,2.956,2.446l.006.062V561.45a2.834,2.834,0,0,1-3.054,2.519h-2.117a2.819,2.819,0,0,1-2.976-2.518v-.041l-.012-11.091V550.3a2.791,2.791,0,0,1,2.957-2.53h2.135Zm.935,2.613,0-.028c-.015-.272-.444-.576-.985-.557h-2.189c-.517,0-.914.29-.93.552l.011,11.028c.023.267.428.561.95.561h2.193c.522,0,.927-.3.951-.564Z",
    transform: "translate(-1383.279 -529.38)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollsIcon);
export default __webpack_public_path__ + "static/media/pollsIcon.d708a7c9497da0ced88581990b6c3470.svg";
export { ForwardRef as ReactComponent };